import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	channelTurnedOff: {
		id: 'servicedesk.channels-jsd.channels.email.channel-turned-off',
		defaultMessage: 'Turned off',
		description: 'Turned part of Message of a turned off channel',
	},
	configure: {
		id: 'servicedesk.channels-jsd.channels.email.configure',
		defaultMessage: 'Configure',
		description: 'Configure a channel',
	},
	configureLabelDescriptive: {
		id: 'servicedesk.channels-jsd.channels.email.configure.label-descriptive',
		defaultMessage: 'Configure email channel',
		description: 'Configure a email channel',
	},
	copyEmail: {
		id: 'servicedesk.channels-jsd.channels.email.copy-email',
		defaultMessage: 'Copy email',
		description: 'Copy Email address to clipboard',
	},
	emailLabel: {
		id: 'servicedesk.channels-jsd.channels.email.email-label',
		defaultMessage: 'EMAIL',
		description: 'Email label',
	},
	emailOffLabel: {
		id: 'servicedesk.channels-jsd.channels.email.email-off-label',
		defaultMessage: 'OFF',
		description:
			'Status of the email channel, states if the project accepts emails from the customers',
	},
	email: {
		id: 'servicedesk.channels-jsd.channels.email.email',
		defaultMessage: 'Email',
		description: 'Email label',
	},
	emailOff: {
		id: 'servicedesk.channels-jsd.channels.email.email-off',
		defaultMessage: 'Off',
		description:
			'Status of the email channel, states if the project accepts emails from the customers',
	},
	emailEnabledLabel: {
		id: 'servicedesk.channels-jsd.channels.email.email-enabled-label',
		defaultMessage: 'ENABLED',
		description:
			'Status of the email channel, states if the project accepts emails from the customers',
	},
});
